import React, { useEffect, useState } from 'react';
import VendorSideMenuBar from '../VendorLayouts/VendorSideMenuBar';
import VendorTopMenuBar from '../VendorLayouts/VendorTopMenuBar';
import '../../../VendorStyles/VendorAnnouncements.css';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import axiosVendorInstance from '../../../axiosVendorInstance';
import { toast } from 'react-toastify';

function VendorAnnouncements() {
    const navigate = useNavigate();
    const [announcements, setAnnouncements] = useState([]);
    const [vendorID, setVendorID] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchVendor = async () => {
            try {
                const response = await axiosVendorInstance.get('/vendors/account');
                const info = response?.data?.getVendorInfo;
                const id = info && info[0]?.ID;
                if (id) setVendorID(id);
            } catch (e) {
                // ignore
            }
        };
        fetchVendor();
    }, []);

    useEffect(() => {
        const fetchAnnouncements = async () => {
            if (!vendorID) return;
            setLoading(true);
            try {
                const url = `https://pro-customers-api.omyfood.io/api/announcements/new?vendor_id=${encodeURIComponent(vendorID)}`;
                const res = await axios.get(url);
                let list = [];
                if (res && (res.status === 200 || res.status === 201)) {
                    const body = res.data;
                    if (Array.isArray(body)) list = body;
                    else if (Array.isArray(body?.data)) list = body.data;
                    else if (Array.isArray(body?.announcements)) list = body.announcements;
                } else if (res && res.status === 204) {
                    list = [];
                }
                setAnnouncements(list || []);
            } catch (e) {
                // Graceful error: show empty state and a brief toast
                setAnnouncements([]);
                toast.error('Unable to fetch announcements');
            } finally {
                setLoading(false);
            }
        };
        fetchAnnouncements();
    }, [vendorID]);

    const handleDelete = async (id) => {
        try {
            await axios.delete(`https://pro-customers-api.omyfood.io/api/announcements/${id}`);
            setAnnouncements((prev) => prev.filter((a) => String(a.id) !== String(id)));
            toast.success('Announcement deleted');
        } catch (e) {
            toast.error('Delete failed');
        }
    };

    const handleEdit = (id) => {
        navigate(`/announcements/edit/${id}`);
    };

    const handleCreate = () => {
        navigate('/announcements/create');
    };

    return (
        <div className="vendor-annc-page">
            <VendorSideMenuBar />
            <VendorTopMenuBar />

            <div className="dashboard-container">
                <div className="vendor-common-container">
                    <div className="vendor-annc-content">
                        <div className="annc-header card-white">
                            <div className="annc-title">Announcements</div>
                            <div className="annc-header-actions">
                                <button className="btn-primary" onClick={handleCreate}>Create Announcement</button>
                            </div>
                        </div>

                        {loading ? (
                            <div className="card-white">Loading...</div>
                        ) : announcements.length === 0 ? (
                            <div className="card-white">
                                <div className="annc-empty">No announcements yet.</div>
                                <button className="btn-primary" onClick={handleCreate}>Create Your First Announcement</button>
                            </div>
                        ) : (
                            <div className="card-white">
                                <div className="annc-list-title">Previous Announcements</div>
                                <div className="annc-list">
                                    {announcements.map((a) => {
                                        const annId = a.id || a.announcement_id || a.notification_id || a.announcementId || a.notificationId;
                                        return (
                                            <div className="annc-row" key={annId || Math.random()}>
                                                <div className="annc-row-main">
                                                    <div className="annc-row-title">{a.title || a?.message_title || 'Untitled'}</div>
                                                    <div className="annc-row-sub">
                                                        <span className={`annc-status ${(a.status || a?.state) === 'sent' ? 'sent' : 'draft'}`}>
                                                            {(a.status || a?.state) === 'sent' ? 'Sent' : 'Draft'}
                                                        </span>
                                                        <span className="annc-dot">&bull;</span>
                                                        <span>{new Date(a.updated_at || a.updatedAt || a.created_at || a.createdAt || Date.now()).toLocaleString()}</span>
                                                        {(() => {
                                                            let items = a.items_json || a.items;
                                                            if (typeof items === 'string') {
                                                                try { items = JSON.parse(items); } catch (_) { items = []; }
                                                            }
                                                            const count = Array.isArray(items) ? items.length : 0;
                                                            return count ? (
                                                                <>
                                                                    <span className="annc-dot">&bull;</span>
                                                                    <span>{count} item(s)</span>
                                                                </>
                                                            ) : null;
                                                        })()}
                                                        {a.vendor_id && (
                                                            <>
                                                                <span className="annc-dot">&bull;</span>
                                                                <span>Vendor #{a.vendor_id}</span>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="annc-row-actions">
                                                    <button className="btn-link" onClick={() => handleEdit(annId)}>Edit</button>
                                                    <button className="btn-link danger" onClick={() => handleDelete(annId)}>Delete</button>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                                <div className="annc-footer">
                                    <button className="btn-primary" onClick={handleCreate}>Create Notification</button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default VendorAnnouncements;
